import { format } from 'date-fns'
import { FULL_DATE } from 'constants/dateFormats'

export function formatFullDate(date) {
  if (!date) return ''
  if (isNaN(new Date(date))) return ''
  return format(date, FULL_DATE)
}
